export default __webpack_public_path__ + "static/media/rappaport.5af67932.png";